// @flow
import React from 'react';
import FontIcon from 'material-ui/FontIcon';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import { ListItem } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Avatar from 'material-ui/Avatar';
import { cyan50, cyan500, orange500 } from 'material-ui/styles/colors';

import type { AuthTokenData, Subscription } from 'reducers/auth';

type Props = {|
  +tokenData: ?AuthTokenData,
  +subscriptions: ?Array<Subscription>,
  +hasSubscription: boolean,
|};

const icon = (which, color = cyan500) => (
  <FontIcon className="material-icons" color={color}>
    {which}
  </FontIcon>
);

const PLAN_LABELS = {
  free: 'Free',
  basic: 'Basic',
  pro: 'Pro',
  proplus: 'Pro+',
};

const getMonogram = (name: string) => {
  const parts = name
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (parts.length === 0) {
    return '';
  }

  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

const getActivePlanLabel = (subscriptions: ?Array<Subscription>) => {
  const activeSubscription = subscriptions
    ? subscriptions.find(subscription => subscription.active)
    : null;

  if (!activeSubscription) {
    return PLAN_LABELS.free;
  }

  return PLAN_LABELS[activeSubscription.plan_code] || PLAN_LABELS.free;
};

const getProfileButtonLabel = (
  tokenData: AuthTokenData,
  subscriptions: ?Array<Subscription>
) => `${getMonogram(tokenData.name)} - ${getActivePlanLabel(subscriptions)}`;

const ProfileMenuButton = ({ tokenData, subscriptions, ...props }: any) =>
  tokenData ? (
    <FlatButton
      className="intro-tour__step-4"
      primary
      label={getProfileButtonLabel(tokenData, subscriptions)}
      icon={icon('person')}
      {...props}
    />
  ) : (
    <IconButton
      className="intro-tour__step-4"
      iconClassName="material-icons"
      tooltip="Regisztráció és bejelentkezés"
      iconStyle={{ color: cyan500 }}
      {...props}
    >
      person
    </IconButton>
  );

const menuItems = ({ tokenData, hasSubscription }: Props) =>
  tokenData
    ? [
        <ListItem
          key="profile-menu__avatar"
          leftAvatar={
            <Avatar
              icon={icon('person')}
              backgroundColor={cyan50}
              color={cyan500}
            />
          }
          primaryText={tokenData.name}
          secondaryText={hasSubscription ? 'Előfizető' : 'Felhasználó'}
          disabled
        />,
        hasSubscription ? null : (
          <ListItem
            key="profile-menu__subscribe"
            disabled
            primaryText={
              <RaisedButton
                buttonStyle={{
                  backgroundColor: orange500,
                }}
                primary
                label="Legyél előfizető!"
                icon={icon('verified_user', 'white')}
                href="/w/subscriptions"
              />
            }
          />
        ),
        <Divider key="profile-menu__divider" />,

        <MenuItem
          key="profile-menu__subscriptions"
          primaryText="Előfizetésem"
          leftIcon={icon('card_membership')}
          href="/w/subscriptions"
        />,
        <MenuItem
          key="profile-menu__profile"
          primaryText="Felhasználói profil"
          leftIcon={icon('person')}
          href="/w/profile"
        />,
        <MenuItem
          key="profile-menu__logout"
          primaryText="Kijelentkezés"
          leftIcon={icon('exit_to_app')}
          href="/w/logout"
        />,
      ]
    : [
        <MenuItem
          key="profile-menu__login"
          primaryText="Bejelentkezés"
          leftIcon={icon('vpn_key')}
          href="/w/login"
        />,
        <MenuItem
          key="profile-menu__register"
          primaryText="Regisztráció"
          leftIcon={icon('person_add')}
          href="/w/register"
        />,
      ];

export default function ProfileMenu({
  tokenData,
  subscriptions,
  hasSubscription,
}: Props) {
  return (
    <IconMenu
      key="profile-menu"
      iconButtonElement={
        <ProfileMenuButton
          tokenData={tokenData}
          subscriptions={subscriptions}
        />
      }
      targetOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
    >
      {menuItems({ tokenData, hasSubscription })}
    </IconMenu>
  );
}



// WEBPACK FOOTER //
// ./components/AppBar/ProfileMenu.js